import { Component } from "react";
import * as React from "react";
import {SubjectItem} from "./pages/onboard/OnboardSubjectMergePage/SubjectItem";
import {SubjectExcludes} from "../models/SchoolWorkloadConfig";
import SdsSubject from "../models/SdsSubject";
import {Dictionary} from "lodash";
import {SubjectMerge} from "../models/SubjectMerge";
import * as _ from "lodash";
import SubjectMergeEditor from "./SubjectMergeEditor";
import RenameSubjectCard from "./pages/onboard/RenameSubjectCard";

interface SubjectRenameEditorProps {
    sdsSubjects: SdsSubject[];
    subjectExcludes?: SubjectExcludes;

    subjectMerges: SubjectMerge[];

    onMergesChanged(subjectMerges: SubjectMerge[]): void;
}

interface SubjectRenameEditorState {
    sdsSubjectDict?: Dictionary<SdsSubject>;
    subjectItems?: SubjectItem[];
}

export default class SubjectRenameEditor extends Component<SubjectRenameEditorProps, SubjectRenameEditorState>
{
    constructor(props: Readonly<SubjectRenameEditorProps>) {
        super(props);
        this.state = {
            sdsSubjectDict: undefined,
            subjectItems: undefined,
        }
    }

    public componentDidMount() {
        this.setSubjectItems();
    }

    private setSubjectItems(): void {
        if (!this.props.subjectMerges || this.props.subjectExcludes === undefined) {
            return;
        }

        const sdsSubjectDict = _.keyBy(this.props.sdsSubjects, "subjectCode");
        const subjectItems = SubjectMergeEditor.calcSubjectItemsFromConfigAndSdsSubjects(this.props.subjectMerges, this.props.subjectExcludes, sdsSubjectDict);

        this.setState({
            subjectItems,
            sdsSubjectDict,
        });
    }
    
    private onSubjectRenamed = (subjectItem: SubjectItem, newName: string) => {

        if(this.state.subjectItems === undefined)
        {
            return;
        }
        
        subjectItem.rename(newName);
        
        let itemsThatAreRenamesOrMerges = this.state.subjectItems.filter(si => si.containsUnSavedRename() || si.containsMerges());
        const newSubjectMerges = itemsThatAreRenamesOrMerges.map(si => si.toSubjectMerge());
        
        this.props.onMergesChanged(newSubjectMerges);
    }
    
    public render() {

        if(this.state.subjectItems === undefined)
        {
            return null;
        }

        const subjectRenameCards =
            this.state.subjectItems.sort(SubjectItem.AlphabeticalCompare)
                .map((subjectItem: SubjectItem, index: number) => {
                    return <RenameSubjectCard
                        key={index}
                        subjectItem={subjectItem}
                        onSubjectRenamed={this.onSubjectRenamed}
                    />;
                });
        
        return (
            <div className={"flex-row flex--flow-wrap flex--justify-content-center"}>
                {subjectRenameCards}
            </div>
        );
    }
}